module.exports = __webpack_public_path__ + "static/media/black-zoom-out-icon.8245aa08.svg";